// extracted by mini-css-extract-plugin
module.exports = {"table":"IntermediaryApplications_table__2XDbj","noItems":"IntermediaryApplications_noItems__3SHUL"};